import '../assets/NcAppNavigationIconBullet-DLQJkObX.css';
import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcAppNavigationIconBullet",
  props: {
    /**
     * The color of the bullet point (as RGB HEX)
     */
    color: {
      type: String,
      required: true,
      validator(color) {
        return /^#?([0-9A-F]{3}){1,2}$/i.test(color);
      }
    }
  },
  emits: ["click"],
  computed: {
    formattedColor() {
      if (this.color.startsWith("#")) {
        return this.color;
      }
      return "#" + this.color;
    }
  },
  methods: {
    onClick(e) {
      this.$emit("click", e);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "app-navigation-entry__icon-bullet", on: { "click": _vm.onClick } }, [_c("div", { style: { backgroundColor: _vm.formattedColor } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "04a313f4"
);
const NcAppNavigationIconBullet = __component__.exports;
export {
  NcAppNavigationIconBullet as default
};
//# sourceMappingURL=NcAppNavigationIconBullet.mjs.map
